/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class r{constructor(r,s,t){this.graphic=r,this.renderingInfo=s,this.layer=t}}export{r as Graphics3DGraphicCreationContext};
